//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { commonStyles } from '../../styles/commonStyles';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../ThemeContext';

/**
 * NavButtons component renders a breadcrumb navigation bar.
 * 'My Loops' is always present, and the current route is appended if not root.
 */

const NavButtons: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { darkMode } = useTheme();
  const crumbs: Array<{ label: string; path: string }> = [
    { label: 'DevOps Loops', path: '/' },
  ];

  const selectSidebarHome = () => {
    window.dispatchEvent(new CustomEvent('selectSidebarHome'));
  };

  return (
    <nav
      style={commonStyles.navigatorContainer(darkMode)}
      aria-label="breadcrumb"
    >
      <span key={crumbs[0].path}>
        <button
          style={commonStyles.button1(darkMode)}
          onClick={() => {
            navigate('/');
            selectSidebarHome();
          }}
        >
          {crumbs[0].label}
        </button>
      </span>
    </nav>
  );
};

export default NavButtons;
